module.exports = __webpack_public_path__ + "img/Sinochem_logo.4f65e1af.png";